/**
 * 全局公共方法
 */
 import axios from '../utils/http';

// 获取微信分享配置
const getShareConfigInfo = params => {
return axios.request({
    data: {
    ...params
    },
    method: 'get',
    url: '/wx/getShareConfigInfo'
})
}

const getProvince = param => { // 根据经纬度获取省份(百度地图接口)
    return axios.request({
        data: {
            location: param.latitude + ',' +
            param.longitude,
        },
        method: 'get',
        url: 'activity/getProvince'
    });
};

const common = {
    getShareConfigInfo,
    getProvince
}
  
export default common